<template>
  <v-app inspire>
    <v-toolbar :color="setting.color" dark fixed app clipped-right>
      <!-- <v-flex xs5 md3 lg2>
        <v-img src="/logo.png"></v-img>
      </v-flex> -->
      <v-flex xs4>
        <v-toolbar-title>
          <label style="font-size:24px;font-weight:bold">{{setting.header}}</label>
            <label>-{{setting.subheader}}</label>
        </v-toolbar-title>
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="openLogin">登录</v-btn>

    </v-toolbar>
    <v-content>

      <v-container grid-list-xs ma-1 pa-1 fluid full-width>
        <v-dialog v-model="dialog" max-width="500px" transition="dialog-transition" persistent>
          <v-card class="elevation-12" @keyup.enter='login'>
            <v-toolbar dark color="primary">
              <v-toolbar-title>系统登录</v-toolbar-title>
              <v-spacer></v-spacer>

            </v-toolbar>
            <v-card-text>
              <v-form @submit="login">

                <v-text-field v-model="loginer.site" v-validate="'required'" data-vv-name="企业"
                  :error-messages="errors.collect('企业')" prepend-icon="mdi-factory" name="site" label="企业" type="text">
                </v-text-field>
                <v-text-field v-model="loginer.name" v-validate="'required'" data-vv-name="用户名"
                  :error-messages="errors.collect('用户名')" prepend-icon="person" name="login" label="用户名" type="text">
                </v-text-field>
                <v-text-field v-model="loginer.pwd" v-validate="'required'" data-vv-name="密码"
                  :error-messages="errors.collect('密码')" prepend-icon="lock" name="password" label="密码" id="password"
                  type="password"></v-text-field>
                <v-progress-linear indeterminate color="green" :active="isBusy"></v-progress-linear>
                <v-alert type="error" :value="loginError" transition="fade-transition">
                  {{result.error}}
                </v-alert>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" type="submit" @click="login">登录</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-layout row wrap align-center justify-center>
          <v-flex xs12 v-for="(item, index) in images" :key="index">
            <v-card darken-1>
              <v-img :src="'/img/zrc/'+item.src"></v-img>
            </v-card>
          </v-flex>
        </v-layout>
        <v-footer style="justify-content:center">
          <a :href="setting.icp_link" target="_blank">{{setting.icp}}</a>
        </v-footer>
      </v-container>
    </v-content>
  </v-app>
</template>

<style scoped>

</style>

<script>
  import Home from "./home.ts";
  export default Home;
</script>